import React from 'react';
import NetworkImage from 'components/Tile/components/NetworkImage';
import theme from './style.css';

const CollectionNetworkImage = props => <NetworkImage theme={theme} {...props} />;

export default CollectionNetworkImage;
